<template>
    <rkm-row>
        <rkm-col cols="3">
            <rkm-form-input
                label="RNE"
                v-model="model.documentos.estrangeiroEntradaBrasil.rne"
                :validations="validations.rne"
                uppercase
            />
        </rkm-col>

        <rkm-col cols="3">
            <rkm-form-date-picker
                :validations="validations.dataEntrada"
                label="Data de entrada no Brasil"
                v-model="model.documentos.estrangeiroEntradaBrasil.dataEntrada"
                :disabled="!model.documentos.estrangeiroEntradaBrasil.rne"
                :min-date="getDataNascimentoString()"
                :max-date="dataAtual"
            />
        </rkm-col>
    </rkm-row>
</template>

<script>
// Moment.
import moment from 'moment'

export default {
    props: {
        dataAtual: { type: String, required: true },
        model: { type: Object, required: true },
    },
    computed: {
        validations() {

            return {
                rne: {
                    max: 20
                },
                dataEntrada: {
                    required: !!this.model.documentos.estrangeiroEntradaBrasil.rne,
                }
            }
        }
    },
    watch: {
        'model.documentos.estrangeiroEntradaBrasil.rne': function (rne) {

            if (!rne) {

                this.model.documentos.estrangeiroEntradaBrasil.dataEntrada = null
            }
        }
    },
    methods: {
        getDataNascimentoString() {

            return this.model.dataNascimento
                ? moment(this.model.dataNascimento).format('DD/MM/YYYY')
                : null
        },
    },
}
</script>